import React from 'react'
import RangeSlider from '../components/RangeSlider/RangeSlider'
import { FormField, Text, TextInput } from 'grommet'
import { NumberInput } from 'grommet-controls'

import { prettyTitle } from './utils'

// Right now every change it saves to the firebase, and then the component has
// to read the data from firebase to reflect the changes. Ideally we would change
// an object cloned from the data, use it to read the component value and then
// throttle the update to firebase.
// This function is also expensive and should not be in production.
const handleChange = (key, value, propertyRef) => {
  propertyRef.update({ [key]: value })
}

export const isRange = (data) => data.startsWith('score')

export const rangeComponent = (data, propertyObject, propertyRef) => {
  return (
    <FormField label={`${prettyTitle(data)}: ${propertyObject[data]}`} htmlFor={data}>
      <RangeSlider
        propertyRef={propertyRef}
        propertyKey={data}
        startsAt={Number(propertyObject[data])}
      />
    </FormField>
  )
  /*(
  <>
    <label htmlFor={data}>
      {prettyTitle(data)}: {propertyObject[data]}
    </label>
    <RangeSlider
      propertyRef={propertyRef}
      propertyKey={data}
      startsAt={Number(propertyObject[data])}
    />

  </>
)*/
}

export const numberComponent = (data, dataRef, propertyObject, propertyRef) => (
  <>
    {/* <label htmlFor={data}>{data}: </label>
    <input
      type="number"
      name={data}
      ref={dataRef}
      value={propertyObject[data]}
      onChange={() => handleChange(data, dataRef.current.value, propertyRef)}
    /> */}

    <FormField label={`${prettyTitle(data)}:`} htmlFor={data}>
      <NumberInput
        ref={dataRef}
        value={propertyObject[data]}
        onChange={() => handleChange(data, dataRef.current.value, propertyRef)}
      />
    </FormField>
  </>
)

export const genericComponent = (data, dataRef, propertyObject, propertyRef) => (
  <>
    {/* <label htmlFor={data}>{data}: </label>
    <input
      type="text"
      name={data}
      ref={dataRef}
      value={propertyObject[data]}
      onChange={() => handleChange(data, dataRef.current.value, propertyRef)}
    /> */}
    <FormField label={`${data}:`} htmlFor={data}>
      <TextInput
        ref={dataRef}
        value={propertyObject[data]}
        onChange={() => handleChange(data, dataRef.current.value, propertyRef)}
      />
    </FormField>
  </>
)

export const descriptionComponent = (data, propertyObject) => (
  <>
    <p>{data}</p>
    <p>{propertyObject[data]}</p>
  </>
)
export const noEdit = ['link'] //['address', 'link', 'monthlyCost', 'operationalCostYear', 'rooms']

export const noEditComponent = (data, propertyObject) => (
  <Text size="small">
    <strong>{prettyTitle(data)}</strong>: {propertyObject[data]}
  </Text>
)

export const sumArray = (accumulator, currentValue) => accumulator + currentValue
export const sumNumbersInArray = (numbersArray) => numbersArray.reduce((a, b) => a + b, 0)
